import { useEffect } from "react";
import { PAGINATION_DEFAULTS, FILE_TYPE, DOCUMENT_STATUS } from "@root/constants";

interface UseDocumentFetchProps {
  isMultiDoc: boolean;
  isLegalChatbot: boolean;
  attachedFile: any[];
  fetchAllDocs: (payload: any) => void;
}

/**
 * Custom hook to fetch documents when component mounts
 */
export const useDocumentFetch = ({
  isMultiDoc,
  isLegalChatbot,
  attachedFile,
  fetchAllDocs,
}: UseDocumentFetchProps) => {
  useEffect(() => {
    if (isMultiDoc || isLegalChatbot) {
      const payload: any = {
        page: 1,
        limit: PAGINATION_DEFAULTS.MAX,
        type: FILE_TYPE.SIMPLE_FILE,
      };
      if (isMultiDoc) {
        payload.type = FILE_TYPE.MULTI_DOC;
        payload.status = DOCUMENT_STATUS.COMPLETED;
      }
      fetchAllDocs(payload);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMultiDoc, isLegalChatbot, attachedFile?.length]);
};
